import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { profileAvatar } from "../component/ImageList";
import baseURL from "../component/baseURL";
import stringsoflanguages from '../component/stringsoflanguages';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import showNotification from '../component/Notification';

const LISTING_MATCH_GRID_SCROLL_KEY = 'yesmls_listingMatch_gridScrollTop';
const LISTING_MATCH_RESTORE_SCROLL_PENDING_KEY = 'yesmls_listingMatch_restoreScrollPending';

function readListingMatchRestorePending() {
    try {
        return typeof sessionStorage !== 'undefined' && sessionStorage.getItem(LISTING_MATCH_RESTORE_SCROLL_PENDING_KEY) === '1';
    } catch {
        return false;
    }
}


export default function ListingMatch() {

    const navigate = useNavigate();
    const location = useLocation();
    const [premiumMembers, setPremiumMembers] = useState([]);
    const [checkFilterStatus, setCheckFilterStatus] = useState(false);
    const [allConnections, setAllConnections] = useState([]);
    const [filteredConnections, setFilteredConnections] = useState([]);
    const [loadData, setLoadData] = useState(false);
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState("");
    const [gearMenuOpen, setGearMenuOpen] = useState(false);
    const [gearSpinning, setGearSpinning] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const gearMenuRef = useRef(null);
    const listScrollRef = useRef(null);
    const [gridHiddenForScrollRestore, setGridHiddenForScrollRestore] = useState(() => readListingMatchRestorePending());

    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        fetchDetailsAPI(userid);
    }, []);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 767);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (gearMenuRef.current && !gearMenuRef.current.contains(e.target)) {
                setGearMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    function persistListingMatchGridScrollForLeave() {
        const el = listScrollRef.current;
        if (el) {
            sessionStorage.setItem(LISTING_MATCH_GRID_SCROLL_KEY, String(el.scrollTop));
        }
        sessionStorage.setItem(LISTING_MATCH_RESTORE_SCROLL_PENDING_KEY, '1');
    }

    useEffect(() => {
        if (!loadData) return undefined;
        const el = listScrollRef.current;
        if (!el) return undefined;
        let timeoutId;
        const onScroll = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                sessionStorage.setItem(LISTING_MATCH_GRID_SCROLL_KEY, String(el.scrollTop));
            }, 120);
        };
        el.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            clearTimeout(timeoutId);
            el.removeEventListener('scroll', onScroll);
        };
    }, [loadData]);

    useLayoutEffect(() => {
        if (!loadData) return undefined;
        if (sessionStorage.getItem(LISTING_MATCH_RESTORE_SCROLL_PENDING_KEY) !== '1') {
            setGridHiddenForScrollRestore(false);
            return undefined;
        }
        const raw = sessionStorage.getItem(LISTING_MATCH_GRID_SCROLL_KEY);
        if (raw == null || raw === '') {
            sessionStorage.removeItem(LISTING_MATCH_RESTORE_SCROLL_PENDING_KEY);
            setGridHiddenForScrollRestore(false);
            return undefined;
        }
        const y = Number(raw);
        if (!Number.isFinite(y) || y < 0) {
            sessionStorage.removeItem(LISTING_MATCH_RESTORE_SCROLL_PENDING_KEY);
            setGridHiddenForScrollRestore(false);
            return undefined;
        }

        const el = listScrollRef.current;
        if (!el) {
            sessionStorage.removeItem(LISTING_MATCH_RESTORE_SCROLL_PENDING_KEY);
            setGridHiddenForScrollRestore(false);
            return undefined;
        }

        const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
        el.scrollTop = y;
        sessionStorage.removeItem(LISTING_MATCH_RESTORE_SCROLL_PENDING_KEY);

        if (reducedMotion) {
            setGridHiddenForScrollRestore(false);
            return undefined;
        }

        requestAnimationFrame(() => {
            setGridHiddenForScrollRestore(false);
        });
        return undefined;
    }, [loadData, filteredConnections.length]);

    function fetchDetailsAPI(userid) {
        console.log(userid)
        if (!userid) {
            console.log('*********No User***********')
        }
        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        fetch(baseURL.URL + '/member/fetch_match_alert', {
            method: 'POST',
            body: formdata

        }).then((response) => response.json())
            .then((responseJson) => {
                const res = responseJson?.response;
                const result = Array.isArray(res?.list)
                    ? res.list
                    : Array.isArray(res?.member_list)
                        ? res.member_list
                        : [];
                console.log(responseJson)
                if (responseJson.server.result_code === 200) {
                    setCheckFilterStatus(responseJson?.response?.filter_on ?? false)
                    setAllConnections(result)
                    setFilteredConnections(result)
                    setLoadData(true)
                }
                else {
                    showNotification('Error', responseJson.server.message, 'danger');
                    setAllConnections([])
                    setFilteredConnections([])
                    setLoadData(false)
                }
            })
            .catch((error) => {
                console.error(error);
                setAllConnections([])
                setFilteredConnections([])
                setLoadData(false)
            })
            .finally(() => {
                setLoading(false);
            });
    }

    function normalizeDisplayValue(value) {
        if (value == null) return "";
        const normalized = String(value).trim();
        if (!normalized) return "";
        const lowered = normalized.toLowerCase();
        if (lowered === "null" || lowered === "undefined") return "";
        return normalized;
    }

    function isMatchAlertItem(item) {
        return item?.listing_details != null;
    }

    function telHref(phone) {
        const p = normalizeDisplayValue(phone);
        return p ? `tel:${p.replace(/\s+/g, "")}` : "#";
    }

    function smsHref(phone) {
        const p = normalizeDisplayValue(phone);
        return p ? `sms:${p.replace(/\s+/g, "")}` : "#";
    }

    function openMatchListing(member) {
        const ld = member.listing_details;
        const listingID = normalizeDisplayValue(ld?.listing_id) || normalizeDisplayValue(ld?.ListingId);
        if (listingID) {
            persistListingMatchGridScrollForLeave();
            navigate("/portfolio-details", {
                state: { listingID, from: location.pathname },
            });
        }
    }

    function navigateToAgentMemberProfile(agentDetails) {
        const memberID = normalizeDisplayValue(agentDetails?.agent_id);
        if (!memberID) {
            showNotification("Error", "Member profile is not available.", "danger");
            return;
        }
        persistListingMatchGridScrollForLeave();
        const scrollPosition = window.scrollY ?? document.documentElement.scrollTop ?? 0;
        sessionStorage.setItem("premiumMembersScrollPosition", String(scrollPosition));
        navigate("/member-profile", {
            state: {
                memberID,
                member: {
                    user_id: memberID,
                    member_fname: normalizeDisplayValue(agentDetails.fname),
                    member_lname: normalizeDisplayValue(agentDetails.lname),
                    member_image: normalizeDisplayValue(agentDetails.picture),
                    member_image_thumb: normalizeDisplayValue(agentDetails.picture_thumb),
                    city_name: normalizeDisplayValue(agentDetails.city_name),
                    country_name: normalizeDisplayValue(agentDetails.country_name),
                },
                scrollPosition,
                from: location.pathname,
            },
        });
    }

    function searchHaystackForMatchAlert(item) {
        const ld = item?.listing_details || {};
        const ad = item?.agent_details || {};
        const cd = item?.consumer_details || {};
        return [
            ld.ListingId,
            ld.PublicRemarks,
            ld.city_name,
            ld.state_name,
            ld.country_name,
            ld.PropertyType,
            ld.StreetName,
            ld.StreetNumber,
            ld.PostalCode,
            item?.match_percentage,
            ad.fname,
            ad.lname,
            ad.email,
            cd.fname,
            cd.lname,
            cd.email,
        ]
            .map((v) => normalizeDisplayValue(v).toLowerCase())
            .filter(Boolean)
            .join(" ");
    }

    function handleSearchByName(event) {
        const value = event.target.value;
        setSearchText(value);
        const normalizedSearch = value.trim().toLowerCase();

        if (!normalizedSearch) {
            setFilteredConnections(allConnections);
            return;
        }

        const filtered = allConnections.filter((member) => {
            if (isMatchAlertItem(member)) {
                return searchHaystackForMatchAlert(member).includes(normalizedSearch);
            }
            const firstName = normalizeDisplayValue(member?.member_fname).toLowerCase();
            const lastName = normalizeDisplayValue(member?.member_lname).toLowerCase();
            const fullName = `${firstName} ${lastName}`.trim();
            return fullName.includes(normalizedSearch);
        });

        setFilteredConnections(filtered);
    }


    const handleMemberCardClick = (member) => {
        persistListingMatchGridScrollForLeave();
        const scrollPosition = window.scrollY ?? document.documentElement.scrollTop ?? 0;
        sessionStorage.setItem('premiumMembersScrollPosition', String(scrollPosition));
        navigate('/member-profile', {
            state: {
                memberID: member.user_id,
                member,
                scrollPosition,
                from: location.pathname
            }
        });
    };

    function navigateToConsumerProfile(cd) {
        persistListingMatchGridScrollForLeave();
        navigate("/premium-home/consumer-profile", {
            state: {
                consumer_details: cd,
                premiumSidebarActive: stringsoflanguages.listingMatch,
            },
        });
    }

    if (loading) {
        return (
            <div className={`content-right listing-match-page${isMobile ? ' feed-recived-page-mobile' : ''} page-loader-wrapper`}>
                <div className="react-js-loader">
                    <div className="react-js-loader-spinner"></div>
                    <p className="react-js-loader-text">{stringsoflanguages.loading}</p>
                </div>
            </div>
        );
    }

    return (
        <div className={`content-right listing-match-page ${isMobile ? 'feed-recived-page-mobile' : ''}`}>
            {/* Search and Filter Section */}
            <div className="search-filter-section">
                <div className="search-bar">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        className="search-icon"
                    >
                        <path
                            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17.5 17.5L13.875 13.875"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <input
                        type="text"
                        placeholder="Search by Name"
                        className="search-input"
                        value={searchText}
                        onChange={handleSearchByName}
                    />
                </div>
                <button className="filter-btn">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M16.4062 4.69678C14.5256 4.69678 12.9441 6.04475 12.5793 7.82178H2.34375C1.91228 7.82178 1.5625 8.17156 1.5625 8.60303C1.5625 9.0345 1.91228 9.38428 2.34375 9.38428H12.5793C12.9441 11.1613 14.5256 12.5093 16.4062 12.5093C18.2869 12.5093 19.8684 11.1613 20.2332 9.38428H22.6562C23.0877 9.38428 23.4375 9.0345 23.4375 8.60303C23.4375 8.17156 23.0877 7.82178 22.6562 7.82178H20.2332C19.8684 6.04475 18.2869 4.69678 16.4062 4.69678ZM16.4062 6.25928C17.7099 6.25928 18.75 7.29938 18.75 8.60303C18.75 9.90668 17.7099 10.9468 16.4062 10.9468C15.1026 10.9468 14.0625 9.90668 14.0625 8.60303C14.0625 7.29938 15.1026 6.25928 16.4062 6.25928Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.59375 12.5093C6.71313 12.5093 5.1316 13.8573 4.76685 15.6343H2.34375C1.91228 15.6343 1.5625 15.9841 1.5625 16.4155C1.5625 16.847 1.91228 17.1968 2.34375 17.1968H4.76685C5.1316 18.9738 6.71313 20.3218 8.59375 20.3218C10.4744 20.3218 12.0559 18.9738 12.4207 17.1968H22.6562C23.0877 17.1968 23.4375 16.847 23.4375 16.4155C23.4375 15.9841 23.0877 15.6343 22.6562 15.6343H12.4207C12.0559 13.8573 10.4744 12.5093 8.59375 12.5093ZM8.59375 14.0718C9.8974 14.0718 10.9375 15.1119 10.9375 16.4155C10.9375 17.7192 9.8974 18.7593 8.59375 18.7593C7.2901 18.7593 6.25 17.7192 6.25 16.4155C6.25 15.1119 7.2901 14.0718 8.59375 14.0718Z"
                            fill="white"
                        />
                    </svg>
                </button>
            </div>
            <span className='listing-count'>{stringsoflanguages.nooflistings}: {filteredConnections.length}</span>
            {/* Member Cards Grid */}
            <div
                className={`member-cards-grid${gridHiddenForScrollRestore ? ' gm-grid--restore-hidden' : ''}`}
                ref={listScrollRef}
            >
                {filteredConnections.map((member, matchIdx) => {
                    if (isMatchAlertItem(member)) {
                        const ld = member.listing_details || {};
                        const ad = member.agent_details || {};
                        const cd = member.consumer_details || {};
                        const cardKey =
                            member?.id ||
                            normalizeDisplayValue(ld?.listing_id) ||
                            normalizeDisplayValue(ld?.ListingId) ||
                            `listing-match-${matchIdx}`;

                        const agentFname = normalizeDisplayValue(ad.fname) || "Agent";
                        const matchPct = normalizeDisplayValue(member?.match_percentage);
                        const bannerText = matchPct
                            ? `${agentFname} ${stringsoflanguages.hasAListingWith} ${matchPct}% ${stringsoflanguages.match}`
                            : `${agentFname} ${stringsoflanguages.hasAListing}`;

                        const agentName = `${normalizeDisplayValue(ad.fname)} ${normalizeDisplayValue(ad.lname)}`.trim() || "N/A";
                        const agentLoc = [
                            normalizeDisplayValue(ad.city_name),
                            normalizeDisplayValue(ad.country_name),
                        ]
                            .filter(Boolean)
                            .join(", ");

                        const agentPhoto =
                            normalizeDisplayValue(ad.picture_thumb) ||
                            normalizeDisplayValue(ad.picture) ||
                            profileAvatar;
                        const companyPhoto =
                            normalizeDisplayValue(ad.company_image_thumb) ||
                            normalizeDisplayValue(ad.company_image) ||
                            "";

                        const consumerName = `${normalizeDisplayValue(cd.fname)} ${normalizeDisplayValue(cd.lname)}`.trim() || "N/A";
                        const consumerLoc = [
                            normalizeDisplayValue(cd.city_name),
                            normalizeDisplayValue(cd.country_name),
                        ]
                            .filter(Boolean)
                            .join(", ");

                        const consumerPhoto =
                            normalizeDisplayValue(cd.picture_thumb) ||
                            normalizeDisplayValue(cd.picture) ||
                            profileAvatar;

                        const agentEmail = normalizeDisplayValue(ad.email);
                        const agentPhone = normalizeDisplayValue(ad.phone);
                        const consumerEmail = normalizeDisplayValue(cd.email);
                        const consumerPhone = normalizeDisplayValue(cd.phone);

                        const noopContact = (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        };

                        return (
                            <div className="listing-match-card" key={cardKey}>
                                <div className="lmc-banner">{bannerText}</div>

                                <div
                                    className="lmc-agent-strip"
                                    role="button"
                                    tabIndex={0}
                                    aria-label={`View profile: ${agentName}`}
                                    onClick={() => navigateToAgentMemberProfile(ad)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            navigateToAgentMemberProfile(ad);
                                        }
                                    }}
                                >
                                    <div className="lmc-circle lmc-circle-agent">
                                        <img src={agentPhoto} alt="" />
                                    </div>
                                    <div className="lmc-agent-meta">
                                        <div className="lmc-accent-name">{agentName}</div>
                                        <div className="lmc-muted-small">{agentLoc || "—"}</div>
                                    </div>
                                    <div className="lmc-circle lmc-circle-company">
                                        {companyPhoto ? (
                                            <img src={companyPhoto} alt="" className="lmc-company-img" />
                                        ) : (
                                            <span className="lmc-placeholder-co">MLS</span>
                                        )}
                                    </div>
                                </div>

                                <div className="lmc-action-gold-row">
                                    <div className="lmc-gold-icons">
                                        <Link
                                            to={agentEmail ? `mailto:${agentEmail}` : "#"}
                                            className={`lmc-gold-btn${!agentEmail ? " is-disabled" : ""}`}
                                            aria-label="Email agent"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (!agentEmail) noopContact(e);
                                            }}
                                        >
                                            <i className="fa-regular fa-envelope" aria-hidden />
                                        </Link>
                                        <span className="lmc-divider-dot" aria-hidden />
                                        <Link
                                            to={telHref(agentPhone)}
                                            className={`lmc-gold-btn${!agentPhone ? " is-disabled" : ""}`}
                                            aria-label="Call agent"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (!agentPhone) noopContact(e);
                                            }}
                                        >
                                            <i className="fa-solid fa-phone" aria-hidden />
                                        </Link>
                                        <span className="lmc-divider-dot" aria-hidden />
                                        <Link
                                            to={smsHref(agentPhone)}
                                            className={`lmc-gold-btn${!agentPhone ? " is-disabled" : ""}`}
                                            aria-label="Message agent"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (!agentPhone) noopContact(e);
                                            }}
                                        >
                                            <i className="fa-regular fa-comment" aria-hidden />
                                        </Link>
                                    </div>
                                    <button
                                        type="button"
                                        className="lmc-show-listing"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            openMatchListing(member);
                                        }}
                                    >
                                        {stringsoflanguages.showListing} →
                                    </button>
                                </div>

                                <div className="lmc-filter-block">
                                    <div className="lmc-filter-label">{stringsoflanguages.filterMatchWith}:</div>
                                    <div
                                        className="lmc-consumer-row"
                                        role="button"
                                        tabIndex={0}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigateToConsumerProfile(cd);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                navigateToConsumerProfile(cd);
                                            }
                                        }}
                                    >
                                        <div className="lmc-circle lmc-circle-consumer">
                                            <img src={consumerPhoto} alt="" />
                                        </div>
                                        <div className="lmc-consumer-meta">
                                            <div className="lmc-accent-name">{consumerName}</div>
                                            <div className="lmc-muted-small">{consumerLoc || "—"}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="lmc-footer-purple">
                                    <Link
                                        to={consumerEmail ? `mailto:${consumerEmail}` : "#"}
                                        className={`lmc-purple-btn${!consumerEmail ? " is-disabled" : ""}`}
                                        aria-label="Email consumer"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!consumerEmail) noopContact(e);
                                        }}
                                    >
                                        <i className="fa-regular fa-envelope" aria-hidden />
                                    </Link>
                                    <Link
                                        to={telHref(consumerPhone)}
                                        className={`lmc-purple-btn${!consumerPhone ? " is-disabled" : ""}`}
                                        aria-label="Call consumer"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!consumerPhone) noopContact(e);
                                        }}
                                    >
                                        <i className="fa-solid fa-phone" aria-hidden />
                                    </Link>
                                    <Link
                                        to={smsHref(consumerPhone)}
                                        className={`lmc-purple-btn${!consumerPhone ? " is-disabled" : ""}`}
                                        aria-label="Message consumer"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!consumerPhone) noopContact(e);
                                        }}
                                    >
                                        <i className="fa-regular fa-comment" aria-hidden />
                                    </Link>
                                </div>
                            </div>
                        );
                    }

                    const firstName = normalizeDisplayValue(member?.member_fname);
                    const lastName = normalizeDisplayValue(member?.member_lname);
                    const fullName = `${firstName} ${lastName}`.trim() || "N/A";
                    const memberSince = normalizeDisplayValue(member?.added_date);
                    const title = normalizeDisplayValue(member?.title) || "N/A";
                    const city = normalizeDisplayValue(member?.city_name);
                    const country = normalizeDisplayValue(member?.country_name);
                    const locationLabel = [city, country].filter(Boolean).join(" - ") || "N/A";
                    const imageUrl =
                        normalizeDisplayValue(member?.member_image_thumb) ||
                        normalizeDisplayValue(member?.member_image) ||
                        profileAvatar;

                    return (
                        <div className="member-card" key={member?.user_id || fullName} onClick={() => handleMemberCardClick(member)}>
                            <div className="member-info">
                                <p className="member-since">
                                    {memberSince ? `Member since ${memberSince}` : "Member since N/A"}
                                </p>
                                <h3 className="member-name">{fullName}
                                    {member?.isPremium == true ? (
                                        <span className="premium-member-star"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                                            <path d="M7.2868 9.91064L10.7796 22.0513L0 9.91064H7.2868Z" fill="#7323ff" />
                                            <path d="M7.42024 8.38808H0L6.86669 2.01175C7.00926 1.87014 7.20204 1.79102 7.403 1.79102H11.2271L7.42024 8.38808Z" fill="#7323ff" />
                                            <path d="M9.1778 8.38811L12.9841 1.7915L16.7905 8.38811H9.1778Z" fill="#7323ff" />
                                            <path d="M17.098 9.91064L12.9842 24.2091L8.87036 9.91064H17.098Z" fill="#7323ff" />
                                            <path d="M18.5481 8.38813L14.7412 1.79102H19.0727C19.2843 1.79102 19.4857 1.87881 19.6298 2.03361L26 8.38813H18.5481Z" fill="#7323ff" />
                                            <path d="M25.9683 9.91064L15.1887 22.0513L18.6815 9.91064H25.9683Z" fill="#7323ff" />
                                        </svg></span>
                                    ) : null}
                                </h3>
                                <p className="member-role">{title}</p>
                                <p className="member-location">{locationLabel}</p>
                            </div>
                            <div className="member-image">
                                <img src={imageUrl} alt={fullName} />
                            </div>
                        </div>
                    );
                })}
            </div>


        </div>
    );
}